module.exports = __webpack_public_path__ + "static/media/location_pin_icon.3a60c632.svg";